import { gql } from 'apollo-angular';

export const scenarioMarketingOverrides = `
  marketingFatigueOverrides {
      productBlendedSegmentIds
      value
  }
  cpiSensitivityToSpendOverrides {
      productBlendedSegmentIds
      value
  }
`;

export const scenarioOrganicsSegment = `
    id
    scenarioId
    autoOrganicFactor
    autoTrueOrganics
    manualOrganicFactor
    manualTrueOrganics
    manualUpdatedAt
    updatedAt
    updatedBy
    warningType      
    productBlendedSegmentId
    productBlendedSegment {
      id
      name
    }
`;

export const scenarioCpiSensitivitySegment = `
    id
    scenarioId
    autoMinimumCpi
    autoCpiSensitivity
    manualMinimumCpi
    manualCpiSensitivity
    manualUpdatedAt
    failureReason
    warningType  
    autoModelConfig
    manualModelConfig
    updatedAt
    updatedBy
    productBlendedSegmentId
    productBlendedSegment {
        id
        name
    }
`;

export const scenarioMarketingFields = `
      paybackMethod
      mappedPaybackMethod
      spendLookbackNumberOfDays
      spendLookbackRelative
      spendLookbackDate
      calibrateOrganicsLastRunTime
      cpiSensitivityCalibrationAutomation
      cpiSensitivityCalibrationMethod
      cpiSensitivityCalibrationLastRunTime
      organicsLookbackNumberOfDays
      organicsLookbackRelative
      organicsLookbackDate
      id
      mode
      scenarioId
      targetPayback
      defaultCpiSensitivityToSpend
      defaultMarketingFatigue
      roasTargetPercentage
      buyClv
      cpiThreshold
      ltvThreshold
      spendThreshold
      blendedSegmentsList {
        edges {
          node {
            segmentId
            segment {
              name
            }
          }
        }
      }
`;

export const SCENARIO_ORGANICS_SEGMENTS_QUERY = gql`
  query scenarioOrganicsSegments($scenarioId: BigInt!) {
    scenarioOrganicsSegments(scenarioId: $scenarioId) {
      edges {
        node {
          ${scenarioOrganicsSegment}
        }
      }
    }
  }
`;

export const SCENARIO_CPI_SENSITIVITY_SEGMENTS_QUERY = gql`
  query scenarioCpiSensitivitySegments($scenarioId: BigInt!) {
    scenarioCpiSensitivitySegments(scenarioId: $scenarioId) {
      edges {
        node {
          ${scenarioCpiSensitivitySegment}
        }
      }
    }
  }
`;

export const SCENARIO_MARKETING_QUERY = gql`
  query scenarioMarketingConfig($scenarioId: BigInt!) {
    scenarioMarketingConfig(scenarioId: $scenarioId) {
      ${scenarioMarketingFields}
      segmentCount
      blendedSegments{
        name
        id
      }
      ${scenarioMarketingOverrides}
      overrideSegmentsForPaid {
        id
        name
      }
      overrideSegmentsForPvc {
        id
        name
      }
    }
  }
`;

export const SCENARIO_MARKETING_CALIBRATE_ORGANICS_MUTATION = gql`
  mutation CalibrateOrganics($method: OrganicsCalibrationMethod!, $scenarioId: BigInt!) {
    calibrateOrganics(method: $method, scenarioId: $scenarioId) {
      organicsSegments {
        ${scenarioOrganicsSegment}
      }
    }
  }
`;

export const SCENARIO_MARKETING_CALIBRATE_CPI_SENSITIVITY_MUTATION = gql`
  mutation CalibrateCpiSensitivity($method: CPISensitivityCalibrationMethodEnum!, $scenarioId: BigInt!) {
    calibrateCpiSensitivity(method: $method, scenarioId: $scenarioId) {
      cpiSensitivitySegments {
        ${scenarioCpiSensitivitySegment}
      }
    }
  }
`;

export const SCENARIO_MARKETING_UPDATE_ORGANICS_MUTATION = gql`
  mutation UpdateScenarioOrganicsSegment($id: UUID!, $manualOrganicFactor: Float, $manualTrueOrganics: Float) {
    updateScenarioOrganicsSegment(id: $id, manualOrganicFactor: $manualOrganicFactor, manualTrueOrganics: $manualTrueOrganics) {
      ${scenarioOrganicsSegment}
    }
  }
`;

export const SCENARIO_MARKETING_UPDATE_CPI_SENSITIVITY_MUTATION = gql`
  mutation UpdateScenarioCpiSensitivitySegment($id: UUID!, $manualMinimumCpi: Float, $manualCpiSensitivity: Float) {
    updateScenarioCpiSensitivitySegment(id: $id, manualMinimumCpi: $manualMinimumCpi, manualCpiSensitivity: $manualCpiSensitivity) {
      ${scenarioCpiSensitivitySegment}
    }
  }
`;

export const SCENARIO_MARKETING_MUTATION = `
  mutation updateMarketingConfig($scenarioId: Int, $scenarioMarketingConfig: ScenarioMarketingConfigInput!) {
    updateMarketingConfig(scenarioId: $scenarioId, scenarioMarketingConfig: $scenarioMarketingConfig) {
      scenarioMarketingConfig {
        ${scenarioMarketingFields}
        overrideSegmentsForPaid {
            id
            name
        }
        overrideSegmentsForPvc {
            id
            name
        }
        scenario {
            config
        }
      }
    }
  }
`;

export const SCENARIO_MARKETING_PVC_PREVIEW_QUERY = `
    query scenarioMarketingPvcPreview($scenarioId: BigInt!, $segmentIds: [String], $cpiSensitivityToSpend: Float!, $marketingFatigue: Float!) {
        scenarioMarketingPvcPreview(scenarioId: $scenarioId, productBlendedSegmentIds: $segmentIds, cpiSensitivityToSpend: $cpiSensitivityToSpend, marketingFatigue: $marketingFatigue) {
            dnuBaseline
            dnuFatigue
            cpiBaseline
            cpiFatigue
            cpiActualLastYear
            cpiActualLookback
            dnuActualLastYear
            dnuActualLookback
            actualsAvg
            pvModel
        }
    }
`;

export const SCENARIO_MARKETING_ORGANICS_PREVIEW_QUERY = gql`
  query organicsPreview($scenarioId: BigInt!) {
    organicsPreview(scenarioId: $scenarioId) {
      allTimeDataPoints {
        x
        y
      }
      lookbackDataPoints {
        x
        y
      }
      fitLinePoints{
        x
        y
      }
    }
  }
`;

export const SCENARIO_MARKETING_ORGANICS_SEGMENT_PREVIEW_QUERY = gql`
  query organicsSegmentPreview($id: UUID!, $manualOrganicFactorOverride: Float, $manualTrueOrganicsOverride: Float) {
    organicsSegmentPreview(id: $id, manualOrganicFactorOverride: $manualOrganicFactorOverride, manualTrueOrganicsOverride: $manualTrueOrganicsOverride) {
      allTimeDataPoints {
        x
        y
      }
      lookbackDataPoints {
        x
        y
      }
      autoFitLinePoints {
        x
        y
      }
      manualFitLinePoints {
        x
        y
      }
    }
  }
`;

export const SCENARIO_MARKETING_CPI_SENSITIVITY_SEGMENT_PREVIEW_QUERY = gql`
  query cpiSensitivitySegmentPreview($id: UUID!, $manualMinimumCpiOverride: Float, $manualCpiSensitivityOverride: Float) {
    cpiSensitivitySegmentPreview(id: $id, manualMinimumCpiOverride: $manualMinimumCpiOverride, manualCpiSensitivityOverride: $manualCpiSensitivityOverride) {
      actualsAvg
      autoCpiBaseline
      autoCpiFatigue
      autoDnuBaseline
      autoDnuFatigue
      autoModel
      cpiActualLastYear
      cpiActualLookback
      cpiActualLookbackDate
      dnuActualLastYear
      dnuActualLookback
      dnuActualLookbackDate
      manualCpiBaseline
      manualCpiFatigue
      manualDnuBaseline
      manualDnuFatigue
      manualModel
    }
  }
`;

export const SCENARIO_MARKETING_OPTIMIZE_CPI_SENSITIVITY_MUTATION = gql`
  mutation optimizeCpiSensitivity($scenarioId: Int) {
    optimizeCpiSensitivity(scenarioId: $scenarioId) {
      scenarioMarketingConfig {
        cpiSensitivityToSpendOverrides {
          productBlendedSegmentIds
          value
        }
        defaultCpiSensitivityToSpend
      }
    }
  }
`;

export const SCENARIO_ORGANICS_CATEGORY_EXCLUSIONS_QUERY = gql`
  query scenarioOrganicsCategoryExclusions($scenarioId: BigInt!) {
    scenarioOrganicsCategoryExclusions(scenarioId: $scenarioId) {
      edges {
        node {
          id
          createdAt
          productCategoryId
          scenarioId
          productCategory {
            category
            id
            value
          }
        }
      }
    }
  }
`;

export const SCENARIO_ORGANICS_ADD_NETWORK_TO_EXCLUSION_LIST_MUTATION = gql`
  mutation addNetworkToExclusionList($productCategoryIds: [String!]!, $scenarioId: BigInt!) {
    addScenarioOrganicsCategoryExclusions(productCategoryIds: $productCategoryIds, scenarioId: $scenarioId) {
      exclusions {
        id
        productCategory {
          category
          value
          id
        }
        productCategoryId
        scenarioId
        createdAt
      }
    }
  }
`;

export const SCENARIO_ORGANICS_REMOVE_NETWORK_FROM_EXCLUSION_LIST_MUTATION = gql`
  mutation removeNetworkFromExclusionList($productCategoryIds: [String!]!, $scenarioId: BigInt!) {
    removeScenarioOrganicsCategoryExclusions(productCategoryIds: $productCategoryIds, scenarioId: $scenarioId) {
      success
    }
  }
`;